import React, { useEffect, useState } from 'react';
import { Spinner } from '../../molecules/spinner';
import { DataTable } from '../../atoms/data-table';
import { PageLayout } from '../../atoms/page-layout';
import { Button } from '../../atoms/button';
import { EditIcon, TickIcon, SuspendIcon } from '../../atoms/icons';
import ManagePayPalDialog, { ManagePayPalDialogTypes } from './ManagePayPalDialog';
import { PayPalCharityDetailsODataModel } from '../../../types/templates/PayPalCharityDetailsODataModel';

export interface ManagePayPalDialogState {
    type: ManagePayPalDialogTypes;
    selectedCharity?: PayPalCharityDetailsODataModel;
}

const ManagePayPalView = function ManagePayPalView() {
    const [isLoading, setIsLoading] = useState(true);
    const [charities, setCharities] = useState<PayPalCharityDetailsODataModel[]>([]);
    const [dialog, setDialog] = useState<ManagePayPalDialogState>({ type: ManagePayPalDialogTypes.Closed });

    const openDialog = (dialogToOpen: ManagePayPalDialogState) => {
        setDialog(dialogToOpen);
    };

    const getCharities = async () => {
        setIsLoading(true);

        try {
            const res = await fetch('/odata/v1.0/paypalcharitydetails?$orderby=CharityName ASC&$count=true');

            if (!res.ok) {
                return;
            }

            const json = await res.json();

            setCharities(json.value);
        } finally {
            setIsLoading(false);
        }
    };

    const closeDialog = (withAction: boolean) => {
        setDialog({ type: ManagePayPalDialogTypes.Closed });

        if (withAction) {
            getCharities();
        }
    };

    useEffect(() => {
        getCharities();
    }, []);

    return (
        <PageLayout>
            <h1 className="typography-title-2 layout-spacing-bottom">PayPal Management</h1>
            {isLoading ? (
                <Spinner />
            ) : (
                <DataTable<PayPalCharityDetailsODataModel>
                    id="paypal-charities"
                    data={charities}
                    headerColumns={[
                        {
                            title: 'Charity',
                        },
                        {
                            title: 'Status',
                        },
                        {
                            title: 'Edit',
                        },
                        {
                            title: 'Suspend/Unsuspend',
                        },
                    ]}
                    renderRow={(charity) => {
                        const {
                            CharityName,
                            CharityKey,
                            PayPalStatus,
                            IsSuspended,
                        } = charity;

                        return (
                            <tr key={CharityKey}>
                                <td>{CharityName}</td>
                                <td>{PayPalStatus}</td>
                                <td>
                                    <Button
                                        id={`${CharityKey}-edit`}
                                        appearance="icon"
                                        onClick={
                                            () => openDialog({ type: ManagePayPalDialogTypes.Edit, selectedCharity: charity })
                                        }
                                    >
                                        <EditIcon />
                                    </Button>
                                </td>
                                <td>
                                    <Button
                                        id={`${CharityKey}-suspend`}
                                        appearance="icon"
                                        onClick={
                                            () => openDialog({ type: ManagePayPalDialogTypes.Suspend, selectedCharity: charity })
                                        }
                                    >
                                        {IsSuspended ? <TickIcon /> : <SuspendIcon />}
                                    </Button>
                                </td>
                            </tr>
                        );
                    }}
                />
            )}
            <ManagePayPalDialog
                dialog={dialog}
                closeDialog={closeDialog}
            />
        </PageLayout>
    );
};

export default ManagePayPalView;
